<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190730-feature-ctdna.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">無入侵性抽血驗癌症 適宜年老病人</div>
                   <div class="post_info">Posted at 09:00h in 癌症</div>
                   <p class="post_wrapper">每當談到癌症檢驗，活組織抽檢往往令不少人卻步，不過現今醫學發展迅速，檢測癌症可用非入侵性方式，而且這項技術愈趨成熟，令風險及成本降低，讓更多人受惠。</p>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190730-non-ivasive-testing.jpg"/>
                        <div class="bottom_tip">無創檢查——液體活檢是分析血液中腫瘤釋放出的DNA，可以知道腫瘤有否基因變異，幫助醫生選擇藥物。</div>
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        病人Y先生，70多歲，患轉移性肺腺癌，不太適合做活組織檢查，因此選擇了運用次世代定序技術（NGS）液體活檢，檢查不具入侵性，速度較快。結果病人檢測到EGFR基因突變，可以使用標靶藥物。
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        活檢，做法是抽取腫瘤組織樣本作病理化驗。以肺癌為例，臨牀診斷為肺癌，需要抽取肺腫瘤樣本，
                        一來要證實是癌症，二來需作病理分類，例如是腺癌還是鱗狀癌，這對治療計劃非常重要。現代癌症病理分析，
                        還需加入分子病理化驗。尤其是癌症範圍比較廣泛，不能做局部治療時，分子及基因分析，有助腫瘤科醫生決定何種治療最適合。
                        標靶治療？哪一種標靶治療？還是化療比較適合？掌握了分子及基因分析，才能做出最客觀及明智決定，對於初診斷的肺癌，或者已經產生耐藥性的肺癌，都同樣重要。
                    </div>

                    <div class="post_wrapper_tip">液體活檢準確度 比組織活檢稍低</div>
                    <div class="post_wrapper_1">
                        那麼什麼是液體活檢？簡單說就是抽取血液的無創檢查，分析血液中腫瘤釋放出的DNA。美國食品及藥物管理局（FDA）在2016批准，血液偵測循環腫瘤DNA的肺癌EGFR基因突變檢測，作為第一個液體活檢，
                        香港以至世界各地對癌症液體活檢的需求迅速增長。現今醫學化驗分析血液中的腫瘤基因技術已日趨成熟，可以知道腫瘤究竟有沒有各種基因變異，幫助醫生選擇藥物。
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        話說回來，有了液體活檢，是否代表組織活檢經毫無用處？事實上，以精準程度來看，組織活檢仍然是第一標準，
                        基於種種原因，液體活檢準確度比組織活檢稍低。因此如果條件許可，組織活檢仍是首選。但實質上有個別情况，例如病人整體健康狀况差、
                        年紀老邁、肺功能差，或有血凝固不良等問題，入侵性活組織檢查有相當風險，液體活檢便有用武之地。
                        雖然準確度比不上活組織，但也不失為一種可行的方法。再者，例如肺癌病情惡化，同時對標靶藥產生抗藥性，入侵性活檢有比較高的風險及困難，液體活檢提供另一個選擇。
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        液體活檢除了能夠幫助醫生選擇治療方法外，亦可應用於其他臨牀領域，例如用於持續監測患者治療成效。除了肺癌外，
                        液體活檢也開始應用於其他癌症類型，如乳癌、結腸癌、胰臟癌和鼻咽癌等。
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        現時組織活檢仍是主流，液體活檢技術還有進步空間。希望於可見未來，液體活檢技術成熟，價格下降，可被廣泛應用。
                    </div>
                    <div class="post_wrapper_1 margin_top" >
                        原文：傅惠霖（臨牀腫瘤科專科醫生）
                    </div>

                    <div class="post_wrapper_1">
                        資料來源：<a href="#">明報健康網</a>
                    </div>
               </div>
           </div>
          <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    font-family: 'Microsoft JhengHei',sans-serif !important;
    margin-bottom:25px;  
    margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:10px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/genstwo.vue